<router-outlet></router-outlet>
<nav class="navbar fixed-bottom navbar-dark bg-dark aqua-gradient">
  <a class="navbar-brand" href="http://lucianonicolasweb.web.app" style="font-size: 14px;">Desarrollado por: <strong
      class="mr-2">N E V R E</strong> dev studio &copy;</a>
</nav>